'use strict';

require('../../style/css');

require('../../icon/style/css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/toast/style/css.js
// module id = 363
// module chunks = 124